import React from 'react';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import ElearningScore from './ElearningScore';

const ELearningPerformance = ({ eLearningScores, canViewTimeSpent }) => {
  return (
    <>
      <h4>{t('progress.report_card.elearning.title')}</h4>
      <Text variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}>
        {t('progress.report_card.elearning.description')}
      </Text>
      <table className="DataTable Table ReportCard-ELearning">
        <thead>
          <tr>
            <th />
            <th className="DataTable-name wide">Content</th>
            <th>{t('progress.report_card.elearning.completion')}</th>
            <th>{t('progress.report_card.elearning.success')}</th>
            <th>{t('progress.report_card.elearning.score')}</th>
            {canViewTimeSpent && (
              <th>{t('progress.report_card.elearning.time_spent')}</th>
            )}
          </tr>
        </thead>
        <tbody>
          {eLearningScores.map(performance => {
            const { registrationId } = performance;
            return (
              <ElearningScore
                key={registrationId}
                id={registrationId}
                canViewTimeSpent={canViewTimeSpent}
                {...performance}
              />
            );
          })}
        </tbody>
      </table>
    </>
  );
};

export default ELearningPerformance;
